import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            white: '#fafafa',
            // color scheme set 3
            limedspruce: '#323CA4', // for csi prod
            lunargreen: '#1A237E', // for csi prod
            // limedspruce: '#365150', // for workdesk
            // lunargreen: '#365136', // for workdesk
            mediumcarmine: '#AB3B46',
            error_red: '#FF0000'
          },
        },
      },
});
